import { ICellRendererParams } from "ag-grid-community";
import startCase from "lodash.startcase";
import pluralize from "pluralize";
import React from "react";

import { IgTypography } from "@intelligems/ig-theme";
import {
  AgencyDto,
  OrganizationSummarySubscriptionProductDto,
} from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { Tag } from "@src/components/BillingPanel/components/Products/components/PriceBox/Tag";
import { AgencyIcon } from "@src/features/admin/components/Icons/AgencyIcon";
import {
  CurrencyFormat,
  DecimalFormat,
} from "@src/features/admin/components/utils";

import { formatDeprecatedName } from "../deprecated-subscription-utils";

export const NameColumn = (
  params: ICellRendererParams<
    OrganizationSummarySubscriptionProductDto & { stripeSubscriptionId: string }
  >
) => {
  const context = params.context as { agencies: AgencyDto[] };

  if (!params.data) {
    return null;
  }

  return (
    <Grid container columnSpacing={2} rowSpacing={1} alignItems={"center"}>
      {context.agencies?.length ? (
        <Grid item alignItems={"center"}>
          <AgencyIcon
            text={`Apart of ${pluralize("Agency", context.agencies.length)}: ${context.agencies.map((a) => a.name).join(", ")}`}
          />
        </Grid>
      ) : null}
      <Grid item>
        <IgTypography variant={"body2"}>
          <IgTypography sx={{ fontWeight: 600 }} variant={"body2"}>
            {params.data.stripeSubscriptionLinkId
              ? params.data.name
              : formatDeprecatedName(params.data.name)}
          </IgTypography>
          <IgTypography variant={"body2"}>
            {" "}
            -
            <br />
            {startCase(params.data.interval) + "ly"}
          </IgTypography>
        </IgTypography>
      </Grid>
      {params.data.subscriptionSummary?.coupon ? (
        <Grid
          item
          sx={{
            "& .MuiBox-root": {
              fontWeight: `500 !important`,
              fontSize: "14px !important",
            },
          }}
        >
          <Tag variant={"success"}>
            {`${params.data.subscriptionSummary.coupon.amountOff ? CurrencyFormat.format(params.data.subscriptionSummary.coupon.amountOff / 100) : params.data.subscriptionSummary.coupon.percentOff + "%"} Off Applied`}
          </Tag>
        </Grid>
      ) : null}
    </Grid>
  );
};
